<template>
	<FormSearchableInput2
		ref="searchable"
		:selected="selected"
		:is-search-loading="isLoading"
		v-bind="$attrs"
		:search="handleSearch"
		@update:selected="$emit('update:selected', $event)"
	/>
</template>
<script>
import Departments from "@/API/Departments.js"
import LoadingMixins from "@/mixins/loading.js"
import FormSearchableInput2 from "@/components/FormSearchableInput2.vue"

export default {
	name: "SelectDepartment",
	mixins: [LoadingMixins],
	model: {
		prop: 'selected',
		event: 'update:selected'
	},
	props: {
		selected: [Object, Number, String],
		disabled: Boolean,
	},
	components: {
		FormSearchableInput2
	},
	data() {
		return {
			list: null
		}
	},
	methods: {
		/**
		 * The backend returns every department, so the search is done here
		 * @param search
		 * @returns {Promise<Array>}
		 */
		async handleSearch(search) {

			if (!await this.load()) return []

			const term = (search ?? '').toLowerCase()

			return this.list.filter(item => item.label?.toLowerCase().includes(term))
		},
		/**
		 * Loads the departments once
		 * @returns {Promise<boolean>}
		 */
		async load() {

			if (this.list) return true

			this.loading()

			const [err, res] = await Departments.getSelect()

			this.loaded()

			if (err) {
				console.error('SelectDepartment@load: Error on loading departments.', {err})
				return false
			}

			// The label comes localized per language and the search needs plain text
			this.list = res.data.data.map(item => ({
				...item,
				label: typeof item.label === 'object' ? this.$localize(item.label) : item.label
			}))

			return true
		},
		focus() {
			this.$refs.searchable.focus()
		},
		clear() {
			this.$refs.searchable.clear()
		}
	}
}
</script>
